import React, { Component } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { connect } from "react-redux";
import { getPaymentDetails } from "../../../api/paymentApi";
import RecentPay from "../Payments/ResentPay";
import PageHeading from "../../Shared/PageHeading";
import CountUp from "react-countup";
import TaxReportCards from "../Dashboard/ReportCards/TaxReportCards";
import PaymentReportCards from "../Dashboard/ReportCards/PaymentReportCards";
import CourierReportCards from "../Dashboard/ReportCards/CourierReportCards";
import ProfitLossCards from "../Dashboard/ReportCards/ProfitLossCards";

import MonthlyGstChart from "../Dashboard/ReportCharts/MonthlyGstChart";
import PaymentMethodChart from "../Dashboard/ReportCharts/PaymentMethodChart";
import PaymentSuccessChart from "../Dashboard/ReportCharts/PaymentSuccessChart";
import CourierShipmentChart from "../Dashboard/ReportCharts/CourierShipmentChart";
import DeliveryTimeChart from "../Dashboard/ReportCharts/DeliveryTimeChart";
import RevenueProfitChart from "../Dashboard/ReportCharts/RevenueProfitChart";
import ProfitWaterfallChart from "../Dashboard/ReportCharts/ProfitWaterfallChart";

import {
  taxReportData,
  monthlyGstData,
  paymentReportData,
  paymentMethodData,
  paymentSuccessData,
  courierReportData,
  courierShipmentData,
  deliveryTimeData,
  profitLossData,
  revenueProfitData,
  profitWaterfallData,
} from "../Dashboard/dashboardReportData";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      payments: [],
      loading: false,
      paymentSummary: {},
      chartData: [],
      activeReport: null,
    };
  }

  fetchPaymentDetails = async () => {
    try {
      const response = await getPaymentDetails();

      if (response.success) {
        const data = response.data;

        this.setState({
          paymentSummary: data,
          chartData: [
            {
              name: "Successful",
              value: data.successfulPayments || 0,
            },
            {
              name: "Pending",
              value: data.pendingPayments || 0,
            },
            {
              name: "Failed",
              value: data.failedPayments || 0,
            },
          ],
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  componentDidMount() {
    this.fetchPaymentDetails();
  }

  render() {
    const COLORS = ["#55DD75", "#EAE26C", "#FC8D98"];
    const { fixNavbar } = this.props;
    return (
      <>
        <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
          <div className="container-fluid np-dashboard-page">
            <div className="row clearfix pt-4">
              <div className="col-6 col-md-4 col-xl-2">
                <div className="card np-dashboard-card">
                  <div className="p-1">
                    <button
                      type="button"
                      className="my_sort_cut text-dark border-0 bg-transparent w-100"
                      onClick={() => this.setState({ activeReport: null })}
                    >
                      <i className="icon-home" aria-hidden="true" />
                      <span>Home</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-4 col-xl-2">
                <div
                  className={`card np-dashboard-card np-dashboard-card--recent-pay ${this.state.activeReport === "recentPay" ? "np-dashboard-card--active" : ""}`}
                >
                  <div className="p-1">
                    <button
                      type="button"
                      className="my_sort_cut text-dark border-0 bg-transparent w-100"
                      onClick={() => this.setState({ activeReport: "recentPay" })}
                    >
                      <i className="icon-wallet" /> <span>Recent Pay</span>
                    </button>
                  </div>
                </div>
              </div>

              {[
                { label: "Profit & Loss", id: "profit", icon: "icon-graph" },
                { label: "Tax Report", id: "tax", icon: "icon-calculator" },
                { label: "Payment Report", id: "payments", icon: "icon-credit-card" },
                { label: "Courier Report", id: "courier", icon: "icon-paper-plane" },
              ].map((report) => (
                <div className="col-6 col-md-4 col-xl-2" key={report.id}>
                  <div
                    className={`card np-dashboard-card ${this.state.activeReport === report.id ? "np-dashboard-card--active" : ""}`}
                  >
                    <div className="p-1">
                      <button
                        type="button"
                        className="my_sort_cut text-dark border-0 bg-transparent w-100"
                        onClick={() => this.setState({ activeReport: report.id })}
                      >
                        <i className={report.icon} />
                        <span>{report.label}</span>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {!this.state.activeReport && (
              <>
                <div className="row clearfix">
                  <div>
                    <h5>Payment Status Overview</h5>
                  </div>

                  <div className="col-md-3">
                    <div className="card np-dashboard-card">
                      <div className="card-body text-center">
                        <h6>Total Transactions</h6>
                        <h3>
                          <CountUp
                            end={this.state.paymentSummary.totalTransactions || 0}
                            duration={2}
                          />
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="card np-dashboard-card">
                      <div className="card-body text-center">
                        <h6>Successful</h6>
                        <h3>
                          <CountUp
                            end={this.state.paymentSummary.successfulPayments || 0}
                            duration={2}
                          />
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="card np-dashboard-card">
                      <div className="card-body text-center">
                        <h6>Pending</h6>
                        <h3>
                          <CountUp
                            end={this.state.paymentSummary.pendingPayments || 0}
                            duration={2}
                          />
                        </h3>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="card np-dashboard-card">
                      <div className="card-body text-center">
                        <h6>Failed</h6>
                        <h3>
                          <CountUp
                            end={this.state.paymentSummary.failedPayments || 0}
                            duration={2}
                          />
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row clearfix mt-4">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-body">
                        <ResponsiveContainer width="100%" height={400}>
                          <PieChart>
                            <Pie
                              data={this.state.chartData}
                              cx="50%"
                              cy="50%"
                              labelLine={false}
                              outerRadius={140}
                              fill="#8884d8"
                              dataKey="value"
                              label={({ name, value }) => `${name}: ${value}`}
                            >
                              {this.state.chartData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                              ))}
                            </Pie>

                            <Tooltip />
                            <Legend />
                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {this.state.activeReport && (
            <div>
              {this.state.activeReport === "recentPay" && <RecentPay />}
              {/* =====================================================
           PROFIT & LOSS
       ====================================================== */}

              {this.state.activeReport === "profit" && (
                <div className="container-fluid mb-4">
                  <PageHeading
                    title="Profit & Loss"
                    className="mb-3"
                    titleClassName="h4 fw-bold mb-0"
                  />

                  <div className="row">
                    <ProfitLossCards data={profitLossData} />
                  </div>

                  <div className="row">
                    <div className="col-xl-6 col-lg-12 mb-4">
                      <RevenueProfitChart data={revenueProfitData} />
                    </div>

                    <div className="col-xl-6 col-lg-12 mb-4">
                      <ProfitWaterfallChart data={profitWaterfallData} />
                    </div>
                  </div>
                </div>
              )}

              {/* =====================================================
           TAX / GST REPORT
       ====================================================== */}

              {this.state.activeReport === "tax" && (
                <div className="container-fluid mb-4">
                  <PageHeading
                    title="Tax (GST) Report"
                    className="mb-3"
                    titleClassName="h4 fw-bold mb-0"
                  />

                  <div className="row">
                    <TaxReportCards data={taxReportData} />
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <MonthlyGstChart data={monthlyGstData} />
                    </div>
                  </div>
                </div>
              )}

              {/* =====================================================
           PAYMENT GATEWAY REPORT
       ====================================================== */}

              {this.state.activeReport === "payments" && (
                <div className="container-fluid mb-4">
                  <PageHeading
                    title="Payment Gateway Report"
                    className="mb-3"
                    titleClassName="h4 fw-bold mb-0"
                  />

                  <div className="row">
                    <PaymentReportCards data={paymentReportData} />
                  </div>

                  <div className="row">
                    <div className="col-xl-6 col-lg-12 mb-4">
                      <PaymentMethodChart data={paymentMethodData} />
                    </div>

                    <div className="col-xl-6 col-lg-12 mb-4">
                      <PaymentSuccessChart data={paymentSuccessData} />
                    </div>
                  </div>
                </div>
              )}
              {/* =====================================================
           COURIER REPORT
       ====================================================== */}

              {this.state.activeReport === "courier" && (
                <div className="container-fluid mb-4">
                  <PageHeading
                    title="Courier Report"
                    className="mb-3"
                    titleClassName="h4 fw-bold mb-0"
                  />

                  <div className="row">
                    <CourierReportCards data={courierReportData} />
                  </div>
                  <div className="row">
                    <div className="col-xl-6 col-lg-12 mb-4">
                      <CourierShipmentChart data={courierShipmentData} />
                    </div>

                    <div className="col-xl-6 col-lg-12 mb-4">
                      <DeliveryTimeChart data={deliveryTimeData} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});
const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
